import { getServerTime, isString, text2time, sec2txt } from '../../../utils/base'

function now (state) {
    const _now = state._now
    const st = getServerTime()
    return _now > st ? _now : st
}

// 时间点判断
function isBefore (state) {
    return time => time > 0 && now(state) < time
}

function isAfter (state) {
    return time => time > 0 && now(state) > time
}

function isBetween (state) {
    return (beginTime, endTime) =>
        beginTime > 0 &&
    endTime > 0 &&
    beginTime <= now(state) &&
    now(state) < endTime
}

// 剩余时长
function leftSecs (state) {
    return endTime => {
        const time = now(state)
        endTime = isString(endTime) ? text2time(endTime) : endTime
        return endTime > time ? Math.ceil((endTime - time) / 1000) : 0
    }
}

function leftFor (_state, getters) {
    return endTime => sec2txt(getters.leftSecs(endTime), 'zh-cn')
}

export default {
    // 当前时间比较
    now,
    isAfter,
    isBefore,
    isBetween,

    // 剩余时长
    leftSecs,
    leftFor
}
